(function () {
  document.querySelectorAll('.livana-landing [data-lvl-hero-gallery]').forEach(function (gallery) {
    var viewport = gallery.querySelector('[data-lvl-hero-viewport]');
    var track = viewport && viewport.querySelector('.lvl-hero__track');
    var slides = gallery.querySelectorAll('[data-lvl-hero-slide]');
    var rail = gallery.querySelector('.lvl-hero__rail-track');
    var thumbs = gallery.querySelectorAll('[data-lvl-hero-thumb]');
    var prev = gallery.querySelector('[data-lvl-hero-prev]');
    var next = gallery.querySelector('[data-lvl-hero-next]');
    var count = slides.length;
    if (!viewport || !track || count < 2) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var current = 0;
    var drag = null;
    var suppressClick = false;

    function metrics() {
      var slide = slides[0];
      var width = slide ? slide.getBoundingClientRect().width : viewport.clientWidth;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      var pad = parseFloat(styles.paddingInlineStart || styles.paddingLeft) || 0;
      var total = pad * 2 + width * count + gap * Math.max(0, count - 1);
      var min = Math.min(0, viewport.clientWidth - total);
      return {
        width: width,
        gap: gap,
        step: width + gap,
        min: min,
        max: 0
      };
    }

    function offsetFor(index) {
      var m = metrics();
      if (m.step <= 0) return 0;
      return Math.max(m.min, Math.min(m.max, -index * m.step));
    }

    function setTransform(offsetPx, animate) {
      var shouldAnimate = animate && !reduceMotion.matches;
      track.style.transition = shouldAnimate ? 'transform 400ms linear' : 'none';
      track.style.transform = 'translate3d(' + offsetPx + 'px, 0, 0)';
    }

    function syncThumbs() {
      thumbs.forEach(function (thumb, i) {
        var active = i === current;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
        if (active && rail) {
          rail.scrollTo({
            left: thumb.offsetLeft,
            top: thumb.offsetTop,
            behavior: reduceMotion.matches ? 'auto' : 'smooth'
          });
        }
      });
    }

    function syncArrows() {
      if (prev) prev.disabled = current === 0;
      if (next) next.disabled = current === count - 1;
    }

    function goTo(index, animate) {
      index = Math.max(0, Math.min(index, count - 1));
      current = index;
      setTransform(offsetFor(current), animate !== false);
      syncThumbs();
      syncArrows();
    }

    function onResize() {
      setTransform(offsetFor(current), false);
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        goTo(i);
      });
    });

    if (prev) {
      prev.addEventListener('click', function () {
        goTo(current - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        goTo(current + 1);
      });
    }

    viewport.addEventListener('pointerdown', function (event) {
      if (event.button != null && event.button !== 0) return;
      if (event.target.closest('[data-lvl-hero-prev], [data-lvl-hero-next]')) return;

      drag = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        origin: offsetFor(current),
        offset: offsetFor(current),
        dragging: false,
        axis: null
      };

      try {
        viewport.setPointerCapture(event.pointerId);
      } catch (err) {
      }
    });

    viewport.addEventListener(
      'pointermove',
      function (event) {
        if (!drag || event.pointerId !== drag.pointerId) return;

        var dx = event.clientX - drag.startX;
        var dy = event.clientY - drag.startY;

        if (!drag.dragging) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          if (Math.abs(dy) > Math.abs(dx)) {
            drag = null;
            return;
          }
          drag.dragging = true;
          drag.axis = 'x';
          track.style.transition = 'none';
        }

        if (drag.axis !== 'x') return;

        var m = metrics();
        var nextOffset = drag.origin + dx;

        if (nextOffset > m.max) nextOffset = m.max + (nextOffset - m.max) * 0.35;
        else if (nextOffset < m.min) nextOffset = m.min + (nextOffset - m.min) * 0.35;

        drag.offset = nextOffset;
        track.style.transform = 'translate3d(' + nextOffset + 'px, 0, 0)';
        if (event.cancelable) event.preventDefault();
      },
      { passive: false }
    );

    function endDrag(event) {
      if (!drag || event.pointerId !== drag.pointerId) return;

      var wasDragging = drag.dragging;
      var m = metrics();
      var index = current;

      if (wasDragging && m.step > 0) {
        var delta = drag.offset - drag.origin;
        if (Math.abs(delta) > m.width * 0.2) {
          index = delta < 0 ? current + 1 : current - 1;
        } else {
          index = Math.round(-drag.offset / m.step);
        }
        suppressClick = true;
      }

      drag = null;
      goTo(index, true);
    }

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);

    viewport.addEventListener(
      'click',
      function (event) {
        if (!suppressClick) return;
        suppressClick = false;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );

    window.addEventListener('resize', onResize);
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(onResize).observe(viewport);
    }

    goTo(0, false);
  });
})();
